window.addEventListener('DOMContentLoaded', () => {
    window.$ = jQuery;
    new RightMenu();
    new ScrollTo();
    new RunBxslider();
    new LoadMore();
    $('a').tooltip();
    $('img').tooltip();
    $('img').tooltip();
    $('abbr').tooltip();
    $('acronym').tooltip();
});